import React from "react";

import  DemandeMotif from "../../../components/demande/DemandeMotif";

const ResiliationMorale = () => {
      return  <DemandeMotif titre="Résiliation personne morale" userId={localStorage.getItem("userId")}  type="entreprise"/>
};

export default ResiliationMorale;
